import { useEffect, useState } from "react";
import api from "../../lib/api";
import { toast } from "sonner";
import { Link2, Unlink } from "lucide-react";
import { Modal, modalBtnPrimary, modalBtnSecondary } from "../Modal";
import { inputCls } from "./TripForm";
import { fmtKc } from "../../lib/format";

// Jen vlastník/admin: dodatečné přiřazení tankování k přijaté faktuře (např. souhrnná faktura CCS / Shell).
export function FuelInvoiceLinkModal({ fueling, onClose, onSaved }) {
    const [invoices, setInvoices] = useState([]);
    const [q, setQ] = useState("");
    const [sel, setSel] = useState(fueling.received_invoice_id || "");
    const [busy, setBusy] = useState(false);
    useEffect(() => { api.get("/received-invoices").then((r) => setInvoices(r.data?.items || r.data || [])).catch(() => toast.error("Přijaté faktury se nepodařilo načíst")); }, []);
    const filtered = invoices.filter((i) => !q || `${i.number || ""} ${i.supplier_name || ""}`.toLowerCase().includes(q.toLowerCase())).slice(0, 100);

    const save = async (id) => {
        setBusy(true);
        try { await api.put(`/fleet/fuelings/${fueling.id}/invoice`, { received_invoice_id: id || null }); toast.success(id ? "Tankování přiřazeno k dokladu" : "Vazba na doklad zrušena"); onSaved(); }
        catch (e) { toast.error(e.response?.data?.detail || "Uložení selhalo"); }
        finally { setBusy(false); }
    };

    return (
        <Modal title="Přiřadit k přijaté faktuře" subtitle={`${(fueling.datetime || "").replace("T", " ")} · ${fueling.vehicle_name} · ${fueling.liters} l`} onClose={onClose} testid="fuel-invoice-modal"
               footer={<>
                   {fueling.received_invoice_id && <button onClick={() => save(null)} disabled={busy} className={`${modalBtnSecondary} mr-auto text-red-700 inline-flex items-center gap-1`} data-testid="fuel-invoice-unlink"><Unlink className="w-3.5 h-3.5" /> Odpojit</button>}
                   <button onClick={onClose} className={modalBtnSecondary}>Zrušit</button>
                   <button onClick={() => save(sel)} disabled={busy || !sel} className={modalBtnPrimary} data-testid="fuel-invoice-save"><Link2 className="w-3.5 h-3.5" /> Přiřadit</button>
               </>}>
            <div className="space-y-3">
                <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Hledat číslo dokladu nebo dodavatele (CCS, Shell…)" className={inputCls} data-testid="fuel-invoice-search" />
                <div className="border border-slate-200 max-h-[50vh] overflow-y-auto" data-testid="fuel-invoice-list">
                    {filtered.length === 0 && <div className="p-4 text-sm text-slate-400 text-center">Žádné přijaté faktury.</div>}
                    {filtered.map((i) => (
                        <label key={i.id} className={`flex items-center gap-3 px-3 py-2.5 border-b border-slate-100 cursor-pointer hover:bg-orange-50/40 ${sel === i.id ? "bg-orange-50" : ""}`}>
                            <input type="radio" name="recv" checked={sel === i.id} onChange={() => setSel(i.id)} className="accent-orange-600" data-testid={`fuel-invoice-option-${i.id}`} />
                            <div className="flex-1 min-w-0 text-sm"><div className="font-medium text-slate-900 truncate">{i.number || "bez čísla"} · {i.supplier_name}</div><div className="text-xs text-slate-500">{i.issue_date || ""}{i.category ? ` · ${i.category}` : ""}</div></div>
                            <div className="text-sm font-semibold tabular-data whitespace-nowrap">{fmtKc(i.total)}</div>
                        </label>
                    ))}
                </div>
            </div>
        </Modal>
    );
}
